import { render, staticRenderFns } from "./ProductsImportModal.vue?vue&type=template&id=d80ee202&"
import script from "./ProductsImportModal.vue?vue&type=script&lang=js&"
export * from "./ProductsImportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports